module.exports = __webpack_public_path__ + "static/media/chenxihuitongji1.cec02d0f.png";